import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles, createStyles, alpha } from '@material-ui/core/styles';
import ActionDelete from '@material-ui/icons/Delete';
import classnames from 'classnames';
import inflection from 'inflection';
import { translate, crudDelete, Button } from 'react-admin';
import Confirm from '../forked/layout/Confirm';

const sanitizeRestProps = ({
  basePath,
  classes,
  crudDelete,
  filterValues,
  handleSubmit,
  handleSubmitWithRedirect,
  invalid,
  label,
  pristine,
  resource,
  saving,
  selectedIds,
  submitOnEnter,
  redirect,
  onSave,
  ...rest
}) => rest;

const styles = theme =>
  createStyles({
    deleteButton: {
      color: theme.palette.error.main,
      '&:hover': {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  });

class DeleteButton extends Component {
  state = { isOpen: false };

  handleClick = e => {
    e.stopPropagation();
    this.setState({ isOpen: true });
  };

  handleDialogClose = e => {
    e.stopPropagation();
    this.setState({ isOpen: false });
  };

  handleDelete = () => {
    const {
      crudDelete,
      resource,
      record,
      basePath,
      redirect,
      onBeforeDelete
    } = this.props;
    onBeforeDelete();
    crudDelete(resource, record.id, record, basePath, redirect);
    this.setState({ isOpen: false });
  };

  render() {
    const {
      classes = {},
      className,
      icon,
      translate,
      resource,
      label = `Delete ${translate(`resources.${resource}.name`, {
        smart_count: 1,
        _: inflection.singularize(resource)
      })}`,
      onClick,
      record,
      onBeforeDelete,
      deleteContent = 'ra.message.delete_content',
      ...rest
    } = this.props;

    return (
      <Fragment>
        <Button
          onClick={this.handleClick}
          label={label}
          className={classnames(
            'ra-delete-button',
            classes.deleteButton,
            className
          )}
          key="button"
          {...sanitizeRestProps(rest)}
        >
          {icon}
        </Button>
        <Confirm
          isOpen={this.state.isOpen}
          title="ra.message.delete_title"
          content={deleteContent}
          translateOptions={{
            name: inflection.humanize(
              translate(`resources.${resource}.name`, {
                smart_count: 1,
                _: inflection.singularize(resource)
              }),
              true
            ),
            id: record.id
          }}
          onConfirm={this.handleDelete}
          onClose={this.handleDialogClose}
        />
      </Fragment>
    );
  }
}

DeleteButton.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  crudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.func
  ]),
  resource: PropTypes.string.isRequired,
  translate: PropTypes.func,
  icon: PropTypes.element
};

DeleteButton.defaultProps = {
  redirect: 'list',
  icon: <ActionDelete />
};

export default connect(null, { crudDelete })(
  translate(withStyles(styles)(DeleteButton))
);
